import './TabContent.css';

import classNames from 'classnames';
import type { FC } from 'react';
import type { ReactNode } from 'react';

interface Props {
  className?: string;
  children: ReactNode;
}

export const TabContent: FC<Props> = ({ children, className }) => (
  <div className={classNames('tab-content', className)}>{children}</div>
);
